"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _logistics = require("@/api/logistics");
var _validate = require("@/utils/validate");
var _dialog = require("@/libs/dialog");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getAdminOrderDelivery, setAdminOrderDelivery } from "../../api/admin";
var _default = exports.default = {
  name: 'GoodsDeliver',
  components: {},
  props: {},
  data: function data() {
    return {
      types: [{
        type: '1',
        title: '发货'
      }, {
        type: '2',
        title: '送货'
      }, {
        type: '3',
        title: '无需发货'
      }],
      active: 0,
      orderId: '',
      delivery: {},
      express: [],
      type: '1',
      deliveryName: '',
      expressCode: '',
      expressNumber: '',
      deliveryTel: ''
    };
  },
  watch: {
    '$route.params.oid': function $routeParamsOid(newVal) {
      var that = this;
      if (newVal != undefined) {
        that.orderId = newVal;
        that.getIndex();
      }
    }
  },
  created: function created() {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/assets/js/media_750'));
    });
  },
  mounted: function mounted() {
    this.orderId = this.$route.params.oid;
    this.getIndex();
    this.getLogistics();
  },
  methods: {
    changeType: function changeType(item, index) {
      this.active = index;
      this.type = item.type;
      this.deliveryName = '';
      this.deliveryTel = '';
      this.expressCode = '';
      this.expressNumber = '';
    },
    getIndex: function getIndex() {
      var _this = this;
      (0, _order.orderDetailApi)({
        orderNo: this.orderId
      }).then(function (res) {
        _this.delivery = res;
      }).catch(function (error) {
        _this.$dialog.error(error.message);
      });
    },
    getLogistics: function getLogistics() {
      var _this2 = this;
      (0, _logistics.expressList)({
        page: 1,
        limit: 999,
        isShow: 1
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this2.express = res.list;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    saveInfo: function () {
      var _saveInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var that, deliveryName, deliveryTel, save, _t, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              // type: '1',
              //   expressRecordType: '1',
              //   expressId: '',
              //   expressCode: '',
              //   deliveryName: '',
              //   deliveryTel: '',
              //   // expressName: '',
              //   expressNumber: '',
              //   expressTempId: '',
              //   toAddr: '',
              //   toName: '',
              //   toTel: '',
              //   orderNo: ''
              that = this, deliveryName = that.deliveryName, deliveryTel = that.deliveryTel, save = {};
              save.type = that.type;
              save.orderNo = that.orderId;
              _t = that.type;
              _context2.n = _t === '1' ? 1 : _t === '2' ? 4 : _t === '3' ? 8 : 9;
              break;
            case 1:
              if (that.expressCode) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, that.$dialog.error('请输入快递公司'));
            case 2:
              if (that.expressNumber) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, that.$dialog.error('请输入快递单号'));
            case 3:
              save.expressNumber = that.expressNumber;
              save.expressRecordType = 1;
              save.expressCode = that.expressCode;
              that.setInfo(save);
              return _context2.a(3, 9);
            case 4:
              _context2.p = 4;
              _context2.n = 5;
              return this.$validator({
                deliveryName: [(0, _validate.required)(_validate.required.message('发货人姓名'))],
                deliveryTel: [(0, _validate.required)(_validate.required.message('发货人电话'))]
              }).validate({
                deliveryName: deliveryName,
                deliveryTel: deliveryTel
              });
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t2 = _context2.v;
              return _context2.a(2, (0, _dialog.validatorDefaultCatch)(_t2));
            case 7:
              save.deliveryName = deliveryName;
              save.deliveryTel = deliveryTel;
              that.setInfo(save);
              return _context2.a(3, 9);
            case 8:
              that.setInfo(save);
              return _context2.a(3, 9);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, this, [[4, 6]]);
      }));
      function saveInfo() {
        return _saveInfo.apply(this, arguments);
      }
      return saveInfo;
    }(),
    setInfo: function setInfo(item) {
      var that = this;
      (0, _order.orderSendApi)(item).then(function (res) {
        that.$dialog.success('发送货成功');
        that.$router.go(-1);
      }, function (error) {
        that.$dialog.error(error.message);
      });
    }
  }
};